export const ConfigFacturaMasiva = {
	barraBusqueda: {
		criterios: [""],
		criteriosKeys: [""],
		criterioPrincipal: "",
		filiales: [] as any[],
		datePicker: true,
		nombreCampoDatePicker: "Fecha Carga (Desde - Hasta)",
	},
	table: {
		title: "Boletas de Honorarios Masivas",
		add: "Subir Documento CSV",
	},
};
